import { FlowProvider, useFlowContext } from '_/contexts/FlowContext';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { useFlowSidebarItems } from '_/features/flows/flowPage/components/useFlowSidebarItems';
import React, { ReactNode, useEffect } from 'react';

interface FlowSectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes FlowContext
 * Separated from provider to avoid circular dependency
 */
function FlowSidebarManager({ children }: FlowSectionProps) {
  const { flowSlug } = useFlowContext();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useFlowSidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.FLOW);
    return () => {
      unregisterContext(CONTEXT_DEPTH.FLOW);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (flowSlug && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.FLOW);
    }
  }, [setSidebarItems, sidebarItems, flowSlug]);

  return <>{children}</>;
}

/**
 * FlowSection - Wrapper for flow-level pages
 * Combines provider and sidebar manager
 */
function FlowSection({ children }: FlowSectionProps) {
  return (
    <FlowProvider>
      <FlowSidebarManager>{children}</FlowSidebarManager>
    </FlowProvider>
  );
}

export default FlowSection;
